import type { Locale } from '@change-corgi/config/locales';

export type AmplitudeLocale =
	| 'de-DE'
	| 'en-AU'
	| 'en-CA'
	| 'en-GB'
	| 'en-IN'
	| 'en'
	| 'es-MX'
	| 'es-AR'
	| 'es-ES'
	| 'fr-FR'
	| 'hi'
	| 'id'
	| 'it'
	| 'ja'
	| 'ko'
	| 'pt-BR'
	| 'ru'
	| 'th'
	| 'tr';

export const AMPLITUDE_LOCALE_MAP: Readonly<Record<Locale, AmplitudeLocale>> = {
	'de-DE': 'de-DE',
	'en-AU': 'en-AU',
	'en-CA': 'en-CA',
	'en-GB': 'en-GB',
	'en-IN': 'en-IN',
	// Mapping en-US to en because it's the default on Amplitude
	'en-US': 'en',
	// This and es-CO are the closest matches for 'es-419' in Amplitude, either of them can be used
	'es-419': 'es-MX',
	'es-AR': 'es-AR',
	'es-ES': 'es-ES',
	'fr-FR': 'fr-FR',
	'hi-IN': 'hi',
	'id-ID': 'id',
	'it-IT': 'it',
	'ja-JP': 'ja',
	// This is a beta locale, it should not show in production
	'ko-KR': 'ko',
	'pt-BR': 'pt-BR',
	'ru-RU': 'ru',
	'th-TH': 'th',
	'tr-TR': 'tr',
};
